import { render } from "./ValidationErrorText.vue?vue&type=template&id=8a321704&scoped=true"
import script from "./ValidationErrorText.vue?vue&type=script&lang=js"
export * from "./ValidationErrorText.vue?vue&type=script&lang=js"

import "./ValidationErrorText.vue?vue&type=style&index=0&id=8a321704&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a321704"]])

export default __exports__